/** Grabs the host app name from the window object.
 * Lots of scary chaining inside - expect no type safety.
 * Mostly used for usage tracking.
 *
 * Returns "local" if the iframe is cross-origin. For example, if the parent app is running
 * locally and `marketplace-embed` is not, or vice versa.
 *
 * @param w - Defaults to the `window` global. Pass `window.parent` if calling from an iframe.
 */
export function getHostAppName(w?: Window) {
  try {
    return (w ?? (window as any))?.hubspot?.bender?.currentProject;
  } catch (e) {
    return 'local';
  }
}
